// src/components/PWAInstallBanner.js
//
// Shows a sticky install-to-home-screen prompt when the browser fires
// the `beforeinstallprompt` event.  Dismissed state persists in localStorage
// so the banner stays away once the user says "Not now".

import { useEffect, useState } from "react";

const STORAGE_KEY = "pwa_install_dismissed";

export default function PWAInstallBanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible]               = useState(false);

  useEffect(() => {
    // Don't show if the user already dismissed or if it's already installed
    if (localStorage.getItem(STORAGE_KEY)) return;
    if (window.matchMedia("(display-mode: standalone)").matches) return;

    const handler = (e) => {
      e.preventDefault();          // block the automatic mini-infobar
      setDeferredPrompt(e);
      setVisible(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      setVisible(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "16px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "12px 18px",
        borderRadius: "14px",
        background: "var(--card)",
        border: "1px solid var(--border)",
        boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
        color: "var(--text)",
        fontSize: "0.85rem",
        maxWidth: "calc(100vw - 32px)",
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ fontSize: "1.4rem", flexShrink: 0 }}>📱</span>
      <span style={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}>
        Add <strong>Marelle Memories</strong> to your home screen
      </span>
      <button
        onClick={handleInstall}
        style={{
          padding: "6px 14px",
          borderRadius: "20px",
          border: "none",
          background: "var(--accent)",
          color: "var(--bg)",
          fontWeight: 700,
          fontSize: "0.8rem",
          cursor: "pointer",
          flexShrink: 0,
        }}
      >
        Install
      </button>
      <button
        onClick={handleDismiss}
        title="Dismiss"
        style={{
          background: "none",
          border: "none",
          color: "var(--text)",
          opacity: 0.5,
          fontSize: "1rem",
          cursor: "pointer",
          flexShrink: 0,
          padding: "0 4px",
          lineHeight: 1,
        }}
      >
        ✕
      </button>
    </div>
  );
}
